module.exports = __webpack_public_path__ + "static/media/seniorzy.05e1e100.svg";